import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';

const styles = {
  card: {
    width: '200px',
    height: '310px',
    margin: '10px',
    display: 'inline-block',
  },
  media: {
    height: '100%',
    border: '3px solid rgba(255, 255, 255, 1)',
  },
  mediaSelected: {
    height: '100%',
    border: '3px solid #2196f3',
  },
};

class DialogComponent extends React.Component {
  renderBackground(classes, elementsList, click, selectedElement) {
    return elementsList.map(image => (
      <Card className={classes.card} key={image._id}>
        <CardMedia
          style={{
            backgroundImage: `url(https://${image.container}.s3.amazonaws.com/${image.blob})`,
          }}
          className={
            selectedElement ===
            `https://${image.container}.s3.amazonaws.com/${image.blob}`
              ? classes.mediaSelected
              : classes.media
          }
          image={`url(https://${image.container}.s3.amazonaws.com/${image.blob})`}
          onClick={click(`https://${image.container}.s3.amazonaws.com/${image.blob}`)}
        />
      </Card>
    ));
  }

  render() {
    const {
      classes,
      dialogType,
      elementsList,
      title,
      open,
      close,
      click,
      clickConfirm,
      selectedElement,
      confirmBtn,
    } = this.props;

    return (
      <Dialog
        open={open}
        onClose={close}
        fullWidth={true}
        maxWidth="md"
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
      >
        <DialogTitle id="scroll-dialog-title">{title}</DialogTitle>
        <DialogContent dividers>
          {dialogType === 'background'
            ? this.renderBackground(classes, elementsList, click, selectedElement)
            : ''}
        </DialogContent>

        <DialogActions>
          <Button onClick={close} color="primary">
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={clickConfirm}
            disabled={selectedElement === 'undefined'}
          >
            {confirmBtn}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(DialogComponent);
